import LineContainerLink from '../line-container/LineContainerLink';

export interface IContextualMenuClearSelectionItemProps {
    text: string;
    dismissMenu: () => void;
    onViewAllClick: () => void;
}

const ContextualMenuClearSelectionItem: React.FC<IContextualMenuClearSelectionItemProps> = ({ text, dismissMenu, onViewAllClick }) => {
    const handleViewAll = () => {
        onViewAllClick();
        dismissMenu();
    };

    return <LineContainerLink handleLinkAction={handleViewAll} linkTitle={text} />;
};

export default ContextualMenuClearSelectionItem;
